import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';
import { getHideFields } from '../../lib/editFieldsConfig';

import FormFields from '../form/fields';
import FormFieldsCompact from '../form/fieldsCompact';
import Input from '../form/input';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewDrug extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('drug'),
        };
    }

    createDrug = async () => {
        const { callback = () => {} } = this.props;
        const { drugStore } = this.props.stores;
        const { newDrug } = drugStore;
        const response = await drugStore.insert(newDrug);
        const drug = response?.data?.drug;
        drugStore.updateKeyValue('newDrug', {});
        if (response.status === 201) {
            callback(drug);
        }
    }

    openFieldsSettings = () => {
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightMediumLarge } = appState;
        appState.openDrawer('editFieldsSettings', {
            entityType: 'drug',
            height: drawerHeightMediumLarge,
        }, drawerLevel + 1);
    }

    componentDidMount() {
        const { id, isNew } = this.props;
        const { drugStore } = this.props.stores;
        if (!isNew) {
            drugStore.load(id);
        }
    }

    render() {
        const { week, isNew, hideAdmin, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, drugStore } = this.props.stores;
        const { user, isAdmin, isCustomerAdmin, customer = {} } = userStore;
        const hideFields = getHideFields(customer, 'drug');
        const { newDrug } = drugStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newDrug, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0 d-flex flex-row justify-content-between align-items-center'>
                        <span>
                            {isNew ? <Text id='drug.new'>New drug</Text> : <Text id='drug.edit'>Edit drug</Text>}
                        </span>
                        {/* me-5 keeps the cog clear of the drawer close X when the drawer is no wider than the content column. */}
                        {isCustomerAdmin && <button type='button' class='btn btn-sm btn-outline-secondary rounded-circle me-5'
                            onClick={this.openFieldsSettings}>
                            <i class='fa-solid fa-gear' />
                        </button>}
                    </div>
                    <div class='d-flex flex-column justify-content-start h-100' style='padding: 0 8px;'>
                        <FormFieldsCompact
                            stores={this.props.stores}
                            sections={sections}
                            holdingStore={drugStore}
                            objectName={isNew ? 'newDrug' : 'drug'}
                            isNew={isNew}
                            drawerLevel={drawerLevel}
                            hideAdmin={hideAdmin}
                            hideFields={hideFields}
                        />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createDrug}>
                            {isNew ? <Text id='drug.create'>Create drug</Text> : <Text id='drug.save'>Save drug</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewDrug;
